import { render, staticRenderFns } from "./suporte-convenios.vue?vue&type=template&id=4b480104"
import script from "./suporte-convenios.vue?vue&type=script&lang=ts"
export * from "./suporte-convenios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports